import clsx from "clsx";
import { forwardRef } from "react";

import styles from "./styles.module.scss";

import type { IPaginationItemProps } from "@components/molecules/pagination/types";

export const PaginationItem = forwardRef<HTMLLIElement, IPaginationItemProps>(
  ({ isActive, ...props }, ref) => (
    <li
      ref={ref}
      className={clsx(styles.paginationItem, {
        [styles.paginationItemActive]: isActive,
      })}
      {...props}
    />
  ),
);
PaginationItem.displayName = "PaginationItem";
